// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281234/js/" + chunkId + "." + {"44":"723291b4","225":"841c98c8","481":"87af51b8","486":"29ce5f69","770":"220a7d7d"}[chunkId] + ".0.013726417881269493.chunk.js";
};